// Module
var code = `<branches-list detail-link="/#!/admin/organization/users"></branches-list>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/users/branches/users-branches.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;